import { createAvailableFileElement } from './common/elements'
import { FRONTEND } from './common/http-request'

type Message = {type: string, [key: string]: any}
type Config = {
    url: string
    handler?: (command: (type: string, message: Omit<Message, 'type'>) => void, modalWindow: Office.Dialog, message: Message) => void
    size?: [number, number]
}

export const createModal = async (context: Word.RequestContext, window, config: Config): Promise<{
    command: (type: string, message: any) => void
    modalWindow: Office.Dialog
}> => {
    return new Promise((resolve, reject) => {
        const url = `${FRONTEND}/${config.url}`.replace(/([^:])\/+/g, '$1/')
        const width = config?.size?.[0] ?? 60
        const height = config?.size?.[1] ?? 95
        Office.context.ui.displayDialogAsync(url, {
            height, 
            width, 
            displayInIframe: true,
        }, (res) => {
            if (res.status != Office.AsyncResultStatus.Succeeded) {
                if (res.error.code === 12007) {
                    setTimeout(() => createModal(context, window, config).then(resolve).catch(reject), 100)
                    return
                }
                console.log(`Failed to open modal:`)
                console.log(res)
                return reject(res.error)
            }
            const modalWindow = res.value
            const command = (type: string, message: any) => {
                modalWindow.messageChild(JSON.stringify(Object.assign(message ?? {}, {type})))
            }

            modalWindow.addEventHandler(Office.EventType.DialogMessageReceived, (arg) => {
                if ('error' in arg) {
                    console.log(`Failed in error handler:`)
                    console.log(arg)
                    modalWindow.close()
                    return reject(arg.error)
                }
                const message = JSON.parse(arg.message) as Message
                console.log('Message from modal window', message)
                if (config.handler) {
                    config.handler(command, modalWindow, message)
                }
            })
            resolve({
                modalWindow,
                command, 
            })
        })
    })
}
